import './styles.css';
import { createRoot } from 'react-dom/client';
import { getActiveAccount } from './accounts';
import { LoginPage } from './pages/LoginPage';

// If a previous login is still stored, skip straight to the app — the user
// stays signed in across browser restarts. The `?add` flag (used by the
// "Add account" link) opts out so a second account can be added.
const wantsAddAccount = new URLSearchParams(window.location.search).has('add');
if (!wantsAddAccount && getActiveAccount()) {
  window.location.replace('/app.html');
} else {
  createRoot(document.getElementById('root')!).render(<LoginPage />);
}
